<template>
    <div>
        <div ref="OilMakerQRScanDistribution" style="min-height: 400px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import moment from 'moment';

    export default {
        data () {
            return {
                chart : null,
                dummyData : [{
                    period : 'January',
                    'activated_AHM OIL MPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 2': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 3': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 2': this.randomInt(100, 500),
                    'activated_Unknown': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 2': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 3': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 2': this.randomInt(100, 500),
                    'totalqr_Unknown': this.randomInt(100, 500)
                    }, {
                    period : 'February',
                    'activated_AHM OIL MPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 2': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 3': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 2': this.randomInt(100, 500),
                    'activated_Unknown': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 2': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 3': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 2': this.randomInt(100, 500),
                    'totalqr_Unknown': this.randomInt(100, 500)
                    }, {
                    period : 'March',
                    'activated_AHM OIL MPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 2': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 3': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 2': this.randomInt(100, 500),
                    'activated_Unknown': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 2': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 3': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 2': this.randomInt(100, 500),
                    'totalqr_Unknown': this.randomInt(100, 500)
                    }, {
                    period : 'April',
                    'activated_AHM OIL MPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 2': this.randomInt(100, 500),
                    'activated_AHM OIL MPX 3': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 1': this.randomInt(100, 500),
                    'activated_AHM OIL SPX 2': this.randomInt(100, 500),
                    'activated_Unknown': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 2': this.randomInt(100, 500),
                    'totalqr_AHM OIL MPX 3': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 1': this.randomInt(100, 500),
                    'totalqr_AHM OIL SPX 2': this.randomInt(100, 500),
                    'totalqr_Unknown': this.randomInt(100, 500)
                    }],
            }
        },
        props : ['data', 'filter'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
               let length = this.chart.data.length;
                let filter = this.filter.filter;
                let data = JSON.parse(JSON.stringify(this.data));
                let indoMonthNames = ['Januari', 'Febuari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

                //If no data
                if (data == null || data.length == 0) data = [{period:'No Data', valid:0, invalid:0}]

                //If filter is CUSTOM
                else if (filter == 'CUSTOM') {
                    for (var i in data) data[i].period = moment(data[i].period).format("DD MMM YY")
                }

                //If filter is DAILY
                else if (filter == 'DAILY') {
                    for (var i in data) data[i].period = `${data[i].period}:00`
                }

                //If filter is WEEKLY
                else if (filter == 'WEEKLY') {
                    for (var i in data) data[i].period = moment(data[i].period).format("ddd, DD MMM")
                }

                //If filter is MONTHLY
                else if (filter == 'MONTHLY') {
                    for (var i in data) data[i].period = `Week ${data[i].period}`
                }

                //If filter is YEARLY
                else if (filter == 'YEARLY') {
                    for (var i in data) data[i].period = indoMonthNames[parseInt(data[i].period)-1].substring(0,3);
                }

                this.chart.addData(data, length);

                // this.chart.addData(this.dummyData && this.dummyData.length > 0 ? this.dummyData : [{period:'No Data', valid:0, invalid:0}],length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.OilMakerQRScanDistribution, am4charts.XYChart);

                // Create axes
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "period";
                // categoryAxis.title.text = "Left Bar = Scan, Right Bar = Deactivate";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.minGridDistance = 20;
                categoryAxis.renderer.cellStartLocation = 0.1;
                categoryAxis.renderer.cellEndLocation = 0.9;

                let  valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.title.text = "Total";

                this.createSeries('activated_AHM OIL MPX1', "MPX1 (Activated)", false);
                this.createSeries('activated_AHM OIL MPX2', "MPX2 (Activated)", true);
                this.createSeries('activated_AHM OIL MPX3', "MPX3 (Activated)", true);
                this.createSeries('activated_AHM OIL SPX1', "SPX1 (Activated)", true);
                this.createSeries('activated_AHM OIL SPX2', "SPX2 (Activated)", true);
                this.createSeries('activated_Unknown', "Unknown (Activated)", true, true, false, 'Activated');

                this.createSeries('totalqr_AHM OIL MPX1', "MPX1 (Total QR)", false);
                this.createSeries('totalqr_AHM OIL MPX2', "MPX2 (Total QR)", true);
                this.createSeries('totalqr_AHM OIL MPX3', "MPX3 (Total QR)", true);
                this.createSeries('totalqr_AHM OIL SPX1', "SPX1 (Total QR)", true);
                this.createSeries('totalqr_AHM OIL SPX2', "SPX2 (Total QR)", true);
                this.createSeries('totalqr_Unknown', "Unknown (Total QR)", true, true, false, 'Total QR');

                // Add legend
                // this.chart.legend = new am4charts.Legend();
                this.chart.cursor = new am4charts.XYCursor();
            },
            // Create series
            createSeries(field, name, stacked, corner=false, isHidden = true, type) {
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = field;
                series.dataFields.categoryX = "period";
                series.name = name;
                // series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
                series.stacked = stacked;
                series.columns.template.width = am4core.percent(95);
                
                if (corner) {
                    series.columns.template.column.cornerRadiusTopLeft = 10;
                    series.columns.template.column.cornerRadiusTopRight = 10;
                }

                // Set up tooltip
                if(!isHidden) {
                    series.adapter.add("tooltipText", (ev) => {
                    var text = `[bold]{categoryX} - ${type}[/]\n`
                    this.chart.series.each((item) => {
                        if (!item.isHidden && item.name.includes(type)) {
                            text += "[" + item.stroke.hex + "]●[/] " + item.name + ": {" + item.dataFields.valueY + "}\n";
                        }
                    });
                    return text;
                });
                }
            }
        }
    }
</script>

<style scoped>

</style>